export const VISUALIZATION_URL = '/neo4j/visualization/:project_id';
export const VISUALIZATION_PUBLIC_URL = '/public/neo4j/visualization/:project_id';
